/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ReplaceMedium(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ReplaceMedium',
      'aria-hidden': true,
      focusable: false,
      width:  14 * scale,
      height: 14 * scale,
      viewBox: '0 0 14 14',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M11.984 8.084a1 1 0 0 0-1.317.516A4 4 0 0 1 7 11a3.97 3.97 0 0 1-2.822-1.178L6 8H1v5l1.767-1.767A5.97 5.97 0 0 0 7 13a6 6 0 0 0 5.5-3.6 1 1 0 0 0-.516-1.316m-.75-5.317A5.98 5.98 0 0 0 7 1a6 6 0 0 0-5.5 3.6 1 1 0 0 0 1.833.8A4 4 0 0 1 7 3c1.105 0 2.098.454 2.822 1.178L8 6h5V1z"}))
}
